import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'

var ReactSuperSelect = require('react-super-select')

class Dynamic extends Component {
	constructor(props) {
		super(props);
		// Determine initial module and type before first render
		let initialView = null;
		let initialSortBy = '';
		let initialType = 'custom';

		for (const mod in props.data) {
			if (props.data[mod] && props.data[mod].hasOwnProperty('schema')) {
				initialView = mod;
				initialSortBy = props.data[mod].sortBy;
				const dd = props.data[mod].settings && Array.isArray(props.data[mod].settings.dropdowns)
					? props.data[mod].settings.dropdowns
					: null;
				if (dd && dd.length > 0) {
					initialType = dd[0]; // use first item in dropdowns
				}
				break;
			}
		}

		this.state = {
			active: false,
			editing: false,
			deleting: false,
			loading: false,
			view: initialView,
			filterBy: {},
			sortBy: initialSortBy,
			sortOrder: 1,
			type: initialType,
			showTypeDropdown: false
		};
		// (Type dropdown methods moved out of constructor)
	}

	edit = (item) => (e) => {
		if (!item) {
			this.setState({ editing: {} })
		} else {
			this.setState({ editing: JSON.parse(JSON.stringify(item)) })
		}
	}

	delete = (item) => (e) => {
		e.stopPropagation()
		this.setState({ deleting: item })
	}

	checkType = (e) => {
		this.setState({ type: e.target.value });
	}

	toggleTypeDropdown = () => {
		this.setState(prevState => ({ showTypeDropdown: !prevState.showTypeDropdown }));
	}

	confirm = (e) => {
		if (this.state.editing) {
			let errorFound = false;

			//dynamic condition definitions
			for (let i of this.props.data[this.state.view].schema) {
				if (i['conditions']) {
					if (i['conditions']['required'] && !this.state.editing[i['name']]) {
						this.setState({ error: 'The ' + i['name'] + ' field is required' });
						errorFound = true;
					} else if (i['conditions']['dateAfter'] && new Date(this.state.editing[i['name']]) < new Date(this.state.editing[i['conditions']['dateAfter']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be after the ' + i['conditions']['dateAfter'] });
						errorFound = true;
					} else if (i['conditions']['dateBefore'] && new Date(this.state.editing[i['name']]) > new Date(this.state.editing[i['conditions']['dateBefore']])) {
						this.setState({ error: 'The ' + i['name'] + ' field must be before the ' + i['conditions']['dateBefore'] });
						errorFound = true;
					} else if (i['conditions']['equalTo'] && this.state.editing[i['name']] != this.state.editing[i['conditions']['equalTo']]) {
						this.setState({ error: 'The ' + i['name'] + ' field must be equal to ' + i['conditions']['equalTo'] });
						errorFound = true;
					}
				}
			}

			if (!errorFound) {
				this.setState({ loading: true });
				this.props.ws.send(JSON.stringify({ route: 'addEditItem', module: this.state.view, item: this.state.editing }))
			}

		} else if (this.state.deleting) {
			this.setState({ loading: true });
			this.props.ws.send(JSON.stringify({ route: 'deleteItem', module: this.state.view, item: this.state.deleting }))
		}
	}

	cancel = (e) => {
		this.setState({ editing: false, deleting: false, loading: false, error: false })
	}

	toggle = (field) => (e) => {
		var newState = this.state.editing
		newState[field] = newState[field] ? false : true
		this.setState({ editing: newState })
	}

	valueChange = (field, type, parentList, index) => (e) => {
		var newState = this.state.editing
		if (!parentList) {
			if (type == 'string') {
				newState[field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			} else if (type == 'number') {
				const v = e.currentTarget.value;
				newState[field] = v === '' ? '' : Number(v);
			}
		} else if (parentList) {
			if (type == 'string') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'longString') {
				newState[parentList][index][field] = e.currentTarget.value
			} else if (type == 'phone') {
				newState[parentList][index][field] = e.currentTarget.value.replace(/\D/gm, '').substr(0, 10)
			} else if (type == 'number') {
				const v = e.currentTarget.value;
				newState[parentList][index][field] = v === '' ? '' : Number(v);
			}
		}

		this.setState({ editing: newState })
	}

	addListItem = (param) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		var newObject = {}
		for (var field of param.schema) {
			newObject[field.name] = ""
		}
		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].push(newObject)

		this.setState({ editing: newState })
	}

	removeListItem = (param, index) => (e) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))

		if (!newState.hasOwnProperty(param.name)) {
			newState[param.name] = []
		}
		newState[param.name].splice(index, 1)

		this.setState({ editing: newState })
	}

	timeSelect = (field) => (datetime) => {
		var newState = this.state.editing

		if (datetime && Math.abs(new Date().getTime() - datetime[0].getTime()) < 1000) {
			newState[field] = '12:00'
		} else if (datetime) {
			newState[field] = datetime[0].getHours() + ':' + datetime[0].getMinutes()
		} else {
			delete newState[field]
		}

		this.setState({ editing: newState })
	}

	clearDateTime = (field) => (e) => {
		var newState = this.state.editing
		delete newState[field]
		this.setState({ editing: newState })
	}

	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirm();
		}
	}

	componentWillMount() { }

	componentWillReceiveProps() {
		if (this.state.loading) {
			this.cancel()
		}
	}

	componentDidMount() {
	}

	renderDynamicInput = (param, value, parentList, index) => {
		if (param instanceof Array) {
			var grouping = []
			for (var subItem of param) {
				grouping.push(this.renderDynamicInput(subItem, parentList ? this.state.editing[parentList][index][subItem.name] : this.state.editing[subItem.name], parentList, index))
			}
			return (<div style={{ display: 'flex' }}>{grouping}</div>)
		} else if (param.type == 'string') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'longString') {
			return (
				<div key={'inputDiv' + param.name} className="snazzyInputBox">
					<textarea className="bigTextInput" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></textarea>
					<label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'phone') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input className="textInput" type="text" required value={value} onChange={this.valueChange(param.name, param.type, parentList, index)} ></input>
					<span className="inputBar"></span><label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'number') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} className="snazzyInputBox">
					<input
						className="textInput"
						type="number"
						required
						value={value}
						onChange={this.valueChange(param.name, param.type, parentList, index)}
						min={param.min !== undefined ? param.min : undefined}
						max={param.max !== undefined ? param.max : undefined}
						step={param.step !== undefined ? param.step : 'any'}
						style={{ boxSizing: 'border-box', paddingRight: '0.5em' }}
					></input>
					<span className="inputBar"></span>
					<label className="textLabel">{param.displayName ? param.displayName : param.name}</label>
				</div>
			)
		} else if (param.type == 'date') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [date[0]] } }) }} />
				</div>
			)
		} else if (param.type == 'startDate') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [new Date(new Date(date[0]).setHours(0, 0, 0, 0))] } }) }} />
				</div>
			)
		} else if (param.type == 'endDate') {
			return (
				<div style={{ flex: "1 1 50%", display: 'inline-block' }} key={'inputDiv' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} value={value} onChange={(date, { name = param.name }) => { this.setState({ editing: { ...this.state.editing, [name]: [new Date(new Date(date[0]).setHours(23, 59, 59, 0))] } }) }} />
				</div>
			)
		} else if (param.type == 'boolean') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<div className="activeBox" onClick={this.toggle(param.name)}>
						<div className={value ? "enabled" : "disabled"}></div>
					</div>
				</div>
			)
		} else if (param.type == 'timeOfDay') {
			return (
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ lineHeight: '57px' }}>{param.displayName ? param.displayName : param.name}</div>
					<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ allowInput: true, dateFormat: "h:i K", noCalendar: true, enableTime: true }} value={value} onChange={this.timeSelect(param.name)} />
					{value ? <div style={{ lineHeight: '57px', cursor: 'pointer' }} onClick={this.clearDateTime(param.name)}>X</div> : ''}
				</div>
			)
		} else if (param.type == 'series') {
			var series = []
			var stopSeries = false
			for (var subItem of param.series) {
				if (subItem instanceof Array) {
					var grouping = []
					var subStopSeries = true
					for (var subSubItem of subItem) {
						if (!this.state.editing.hasOwnProperty(subSubItem.name) || this.state.editing[subSubItem.name] == '' || this.state.editing[subSubItem.name] == null) {
							if (!stopSeries) { grouping.push(this.renderDynamicInput(subSubItem, this.state.editing[subSubItem.name])) }
						} else {
							subStopSeries = false
							grouping.push(this.renderDynamicInput(subSubItem, this.state.editing[subSubItem.name]))
						}
					}
					series.push(<div style={{ display: 'flex' }} key={'groupInput' + subSubItem.name}>{grouping}</div>)
					if (subStopSeries) {
						stopSeries = true
					}
				} else {
					if (!this.state.editing.hasOwnProperty(subItem.name) || this.state.editing[subItem.name] == "" || this.state.editing[subItem.name] == null) {
						if (!stopSeries) { series.push(this.renderDynamicInput(subItem, this.state.editing[subItem.name])) }
						stopSeries = true
					} else {
						series.push(this.renderDynamicInput(subItem, this.state.editing[subItem.name]))
					}
				}
			}
			return (<div key={'seriesInput' + param.name}>{series}</div>)
		} else if (param.type == 'dynamicDropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<ReactSuperSelect ajaxDataFetch={() => { return new Promise(async (res, rej) => { var response = await fetch(window.location.origin + '/data?path=' + param.path); if (response.ok) { var ddArray = []; var ddItems = await response.json(); for (var ddItem in ddItems) { ddArray.push({ id: ddItems[ddItem][param.param], name: ddItems[ddItem][param.param] }) }; res(ddArray) }; }) }} initialValue={{ id: this.state.editing[param.name], name: this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name)} />
				</div>
			)
		} else if (param.type == 'dropdown') {
			return (
				<div style={{ flex: "1 1 50%" }} key={'inputDiv' + param.name} >
					<div>{param.displayName ? param.displayName : param.name}</div>
					<ReactSuperSelect dataSource={param.options} initialValue={{ id: parentList ? this.state.editing[parentList][index][param.name] : this.state.editing[param.name], name: parentList ? this.state.editing[parentList][index][param.name] : this.state.editing[param.name] }} onChange={this.selectDDDValue(param.name, parentList, index)} />
				</div>
			)
		} else if (param.type == 'list') {
			var list = []
			if (this.state.editing[param.name] && this.state.editing[param.name].length > 0) {
				for (var [i, subItem] of this.state.editing[param.name].entries()) {
					console.log(subItem)
					var listItem = []
					for (var field of param.schema) {
						listItem.push(this.renderDynamicInput(field, this.state.editing[param.name][i][field.name], param.name, i))
					}
					list.push(
						<div style={{ position: 'relative' }}>
							<div onClick={this.removeListItem(param, i)} style={{ cursor: 'pointer', position: 'absolute', right: '-25px', top: '40%' }}>X</div>
							{listItem}
							<hr />
						</div>
					)
				}
			}
			return (
				<div key={'listInput' + param.name}>
					<div>{param.displayName ? param.displayName : param.name}</div>
					<hr />
					{list}
					<div style={{ width: '150px', margin: '10px auto', cursor: 'pointer', border: '1px solid #2A6AA9', padding: '5px 10px' }} onClick={this.addListItem(param)}>{list.length > 0 ? '+ Add Another' : '+ Add An Item'}</div>
				</div>)
		} else if (param.type == 'static') {
			return (
				<div style={{ flex: "1 1 100%", margin: '10px 0' }} key={'inputDiv' + param.name}>
					<div style={{ fontSize: '12px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' }}>
						{param.displayName ? param.displayName : param.name}
					</div>
					<div style={{ fontSize: '22px', fontWeight: 700, color: '#137', lineHeight: '28px' }}>
						{value}
					</div>
					<hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', marginTop: '8px' }} />
				</div>
			)
		}
	}

	selectDDDValue = (field, parentList, index) => (valueObject) => {
		var newState = JSON.parse(JSON.stringify(this.state.editing))
		if (parentList) {
			if (valueObject && valueObject.name) {
				newState[parentList][index][field] = valueObject.name
			} else {
				delete newState[parentList][index][field]
			}
		} else {
			if (valueObject && valueObject.name) {
				newState[field] = valueObject.name
			} else {
				delete newState[field]
			}
		}

		this.setState({ editing: newState })
	}

	getDisplayIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.displayName ? subItem.displayName : subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	getIdentifier = (item) => {
		var oneLevelDeeper = (subItem) => {
			if (subItem instanceof Array) {
				return oneLevelDeeper(subItem[0])
			} else {
				return subItem.name
			}
		}
		return oneLevelDeeper(this.props.data[this.state.view].schema[0])
	}

	sort = (sortBy) => (e) => {
		var sortOrder
		if (this.state.sortOrder === -1) {
			sortOrder = 1;
		} else {
			sortOrder = -1;
		}
		this.setState({ sortBy: sortBy, sortOrder: sortOrder })
	}

	filter = (field) => (e) => {
		var filterBy = this.state.filterBy
		if (e.target.value.length > 0) {
			filterBy[field] = e.target.value
		} else {
			delete filterBy[field]
		}
		this.setState({ filterBy: filterBy })
	}

	sortFunc = (sortBy, sortOrder) => {
		return function (a, b) {
			if (sortBy === "status" || sortBy === "ActivityDateTime") {
				if ('status' in a && 'status' in b) {
					if (!a.loggedIn && !b.loggedIn) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					} else if (!a.loggedIn) {
						return 1
					} else if (!b.loggedIn) {
						return -1
					}
					if (a[sortBy] === b[sortBy]) {
						return a.username > b.username ? 1 * sortOrder : -1 * sortOrder
					}
					return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
				} else {
					if ('status' in a) {
						return -1
					}
					return 1
				}
			}

			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.email > b.email ? 1 * sortOrder : -1 * sortOrder
			} else {
				return sortBy in a ? -1 : 1
			}
		}
	}

	filterFunc = (array, filterBy) => {
		return array.filter(function (object) {
			for (var prop in filterBy) {
				if (typeof object[prop] === "undefined") {
					return false
				}
				if (object[prop] == null || object[prop] == undefined || object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
					return false
				}
			}
			return true;
		})
	}

	filterIcon = (item) => {
		return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
	}

	renderTruncatedString = (value, maxChars = 15) => {
		const str = (value === null || value === undefined) ? '' : String(value);
		const shouldTruncate = str.length > maxChars;
		const display = shouldTruncate ? str.slice(0, maxChars) + '…' : str;
		return (
			<span
				title={str}
				style={{
					display: 'inline-block',
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					maxWidth: '100%'
				}}
			>
				{display}
			</span>
		);
	}

	render() {
		console.log('this.props.data');
		console.log(this.props.data);
		if (this.props.active) {
			var items = []

			for (var id in this.props.data[this.state.view].data) {
				items.push(this.props.data[this.state.view].data[id]);
			}

			// Apply dynamic dropdown filter on 'Dropdown' field if a type is selected
			if (
				this.props.data[this.state.view].settings &&
				Array.isArray(this.props.data[this.state.view].settings.dropdowns) &&
				this.props.data[this.state.view].settings.dropdowns.length > 0
			) {
				const t = this.state.type;
				if (t) {
					items = items.filter((it) => (it && typeof it === 'object' && 'Dropdown' in it) ? it.Dropdown === t : false);
				}
			}

			//Filtering items List
			if (Object.keys(this.state.filterBy).length > 0) {
				items = this.filterFunc(items, this.state.filterBy)
			}

			//Sorting filtered items List
			if (this.state.sortBy !== '') {
				items.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
			}

			// Build table rows
			var tableRows = []
			for (var item of items) {
				var cells = []
				for (var displayParam of this.props.data[this.state.view].schema) {
					if (displayParam instanceof Array) {
						for (var subItem of displayParam) {
							if (subItem.display) {
								let cellContent = '';
								let cellStyle = { minWidth: '125px', textAlign: 'left' };

								switch (subItem.type) {
									case 'boolean':
										cellContent = item[subItem.name] ? (
											<div style={{
												backgroundColor: '#2A6AA9',
												color: 'white',
												borderRadius: '50%',
												height: '20px',
												width: '20px',
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center'
											}}>
												<svg width="10" height="8" viewBox="0 0 10 8">
													<path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
												</svg>
											</div>
										) : null;
										cellStyle = { minWidth: '100px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' };
										break;
									case 'date':
										cellContent = item[subItem.name] ? new Date(item[subItem.name]).toLocaleDateString('en-US', {
											month: 'short',
											day: 'numeric',
											year: 'numeric'
										}) : '';
										break;
									case 'startDate':
									case 'endDate':
										cellContent = item[subItem.name] ? new Date(item[subItem.name]).toLocaleString('en-US', {
											month: 'short',
											day: 'numeric',
											year: 'numeric',
											hour: 'numeric',
											minute: 'numeric',
											hour12: true
										}) : '';
										break;
									case 'string':
										cellContent = this.renderTruncatedString(item[subItem.name]);
										break;
									default:
										cellContent = this.renderTruncatedString(item[subItem.name]);
										break;
								}

								cells.push(
									<td key={item.id + '_' + subItem.name} style={cellStyle}>
										{cellContent}
									</td>
								)
							}
						}
					} else {
						if (displayParam.display) {
							let cellContent = '';
							let cellStyle = { minWidth: '100px', textAlign: 'left' };

							switch (displayParam.type) {
								case 'boolean':
									cellContent = item[displayParam.name] ? (
										<div style={{
											backgroundColor: '#2A6AA9',
											color: 'white',
											borderRadius: '50%',
											height: '20px',
											width: '20px',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center'
										}}>
											<svg width="10" height="8" viewBox="0 0 10 8">
												<path fill="currentColor" d="M10 1.5L3.5 8L0 4.5L1.5 3L3.5 5L8.5 0L10 1.5Z"></path>
											</svg>
										</div>
									) : null;
									cellStyle = { minWidth: '100px', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' };
									break;
								case 'date':
									cellContent = item[displayParam.name] ? new Date(item[displayParam.name]).toLocaleDateString('en-US', {
										month: 'short',
										day: 'numeric',
										year: 'numeric'
									}) : '';
									break;
								case 'startDate':
								case 'endDate':
									cellContent = item[displayParam.name] ? new Date(item[displayParam.name]).toLocaleString('en-US', {
										month: 'short',
										day: 'numeric',
										year: 'numeric',
										hour: 'numeric',
										minute: 'numeric',
										hour12: true
									}) : '';
									break;
								case 'string':
									cellContent = this.renderTruncatedString(item[displayParam.name]);
									break;
								default:
									cellContent = item[displayParam.name];
									break;
							}

							cells.push(
								<td key={item.id + '_' + displayParam.name} style={cellStyle}>
									{cellContent}
								</td>
							)
						}
					}
				}

				// Add delete button cell if needed
				if (this.props.data[this.state.view].actions.delete) {
					cells.push(
						<td key={item.id + '_delete'} style={{ minWidth: '50px', textAlign: 'center' }}>
							<img
								src={this.props.img.delete}
								alt="Delete"
								onClick={this.delete(item)}
								style={{ cursor: 'pointer' }}
							/>
						</td>
					)
				}

				tableRows.push(
					<tr
						key={item.id}
						className="dataRow"
						onClick={this.props.data[this.state.view].actions.edit ? this.edit(item) : ''}
						style={{ cursor: this.props.data[this.state.view].actions.edit ? 'pointer' : 'default' }}
					>
						{cells}
					</tr>
				)
			}

			// Check if filters should be shown (default to false if not specified)
			const showFilters = this.props.data[this.state.view].settings &&
				this.props.data[this.state.view].settings.showFilters === true;

			// Build filter inputs for sidebar
			var filterInputs = []
			if (showFilters) {
				for (var param of this.props.data[this.state.view].schema) {
					if (param instanceof Array) {
						for (var subItem of param) {
							if (subItem.filter !== false) {
								filterInputs.push(
									<div key={'filter_' + subItem.name} style={{ width: '150px', marginBottom: '10px' }}>
										<label>{subItem.displayName ? subItem.displayName : subItem.name}:</label>
										<input
											type="text"
											onChange={this.filter(subItem.name)}
											value={this.state.filterBy[subItem.name] || ''}
											style={{ width: '100%', padding: '5px', margin: '2px 0' }}
										/>
									</div>
								)
							}
						}
					} else {
						if (param.filter !== false) {
							filterInputs.push(
								<div key={'filter_' + param.name} style={{ width: '150px', marginBottom: '10px' }}>
									<label>{param.displayName ? param.displayName : param.name}:</label>
									<input
										type="text"
										onChange={this.filter(param.name)}
										value={this.state.filterBy[param.name] || ''}
										style={{ width: '100%', padding: '5px', margin: '2px 0' }}
									/>
								</div>
							)
						}
					}
				}
			}

			// Build table headers
			var tableHeaders = []
			for (var param of this.props.data[this.state.view].schema) {
				if (param instanceof Array) {
					for (var subItem of param) {
						if (subItem.display) {
							let headerStyle = { minWidth: '125px', cursor: 'pointer', textAlign: 'left' };
							if (subItem.type === 'boolean') {
								headerStyle.textAlign = 'center';
							}
							tableHeaders.push(
								<th
									key={'header_' + subItem.name}
									style={headerStyle}
									onClick={this.sort(subItem.name)}
								>
									{(subItem.headerName ? subItem.headerName : (subItem.displayName ? subItem.displayName : subItem.name)) + this.filterIcon(subItem.name)}
								</th>
							)
						}
					}
				} else {
					if (param.display) {
						let headerStyle = { minWidth: '100px', cursor: 'pointer', textAlign: 'left' };
						if (param.type === 'boolean') {
							headerStyle.textAlign = 'center';
						}
						tableHeaders.push(
							<th
								key={'header_' + param.name}
								style={headerStyle}
								onClick={this.sort(param.name)}
							>
								{(param.displayName ? param.displayName : param.name) + this.filterIcon(param.name)}
							</th>
						)
					}
				}
			}

			// Add delete header if needed
			if (this.props.data[this.state.view].actions.delete) {
				tableHeaders.push(
					<th key={'header_actions'} style={{ minWidth: '50px', textAlign: 'center' }}>
						Actions
					</th>
				)
			}

			var editing, deleting
			if (this.state.editing) {
				var editfields = []
				for (var param of this.props.data[this.state.view].schema) {
					editfields.push(this.renderDynamicInput(param, this.state.editing[param.name]))
				}
				editing = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							{editfields}

							<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}

			if (this.state.deleting) {
				deleting = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}></div>

							<div>You are removing</div>
							<div style={{ padding: '25px' }}>{this.getDisplayIdentifier(this.props.data[this.state.view].schema[0])}: {this.state.deleting[this.getIdentifier(this.props.data[this.state.view].schema[0])]} </div>
							{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirm}>Confirm</div>}
						</div>
					</div>
				)
			}

			return (
				<div width="100%">
					{this.props.data[this.state.view].actions.add &&
						<img src={this.props.img.plus} className="plusButton" alt="Add" onClick={this.edit(null)} />
					}
					{/* Type dropdown selector */}
					{this.props.data[this.state.view].settings?.dropdowns?.length > 0 && (
						<div style={{ width: '280px', marginRight: '10px' }}>
							<div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
								<label className="switch">
									<div style={{ width: '250px' }}>
										<select
											value={this.state.type}
											onChange={this.checkType}
											style={{
												flex: '1 0 0',
												marginBottom: '5px',
												height: '40px',
												padding: '0 10px',
												border: '1px solid #ddd',
												borderRadius: '4px',
												fontWeight: 'bold',
												fontSize: '20px',
												color: '#137',
												lineHeight: '24px'
											}}
										>
											{this.props.data[this.state.view].settings.dropdowns.map((typeOption) => (
												<option key={typeOption} value={typeOption}>
													{typeOption.charAt(0).toUpperCase() + typeOption.slice(1)}
												</option>
											))}
										</select>
									</div>
								</label>
							</div>
						</div>
					)}

					<div style={{ display: 'flex', alignItems: 'flex-start' }}>
						{showFilters && (
							<div style={{
								width: '210px',
								marginRight: '20px',
								alignSelf: 'flex-start',
								backgroundColor: 'white'
							}}>
								<div className="filterBox" style={{ boxSizing: 'border-box', width: '100%' }}>
									<h4>Filter By:</h4>
									{filterInputs}
								</div>
							</div>
						)}
						<div style={{ flex: 1 }}>
							<div style={{ overflowX: 'auto', overflowY: 'visible', maxHeight: 'none' }}>
								<table style={{ width: '100%' }}>
									<thead>
										<tr className="dataRow">
											{tableHeaders}
										</tr>
									</thead>
									<tbody>
										{tableRows}
									</tbody>
								</table>
							</div>
						</div>
					</div>

					{editing}
					{deleting}
				</div>
			);
		} else {
			return (
				<div width="100%">
				</div>
			);
		}
	}
}

const icon = "menuObject"
export { Dynamic, icon }
// Type dropdown methods
